import type { Entry, EntryFieldTypes, EntrySkeletonType } from 'contentful'

import { type TypeComponentCtaButtonSkeleton } from './component-cta-button'
import { type TypeVariationContainerAuthAndDeviceTypeCtaSkeleton } from './variation-container-auth-and-device-type-cta'

export enum CtaGroupLayout {
  Row = 'Row',
  Column = 'Column',
}

export interface TypeComponentCtaGroupFields {
  internalName: EntryFieldTypes.Symbol
  layout: EntryFieldTypes.Symbol<CtaGroupLayout>
  ctAs:
    | EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeComponentCtaButtonSkeleton>>
    | EntryFieldTypes.Array<
        EntryFieldTypes.EntryLink<TypeVariationContainerAuthAndDeviceTypeCtaSkeleton>
      >
}

export type TypeComponentCtaGroupSkeleton = EntrySkeletonType<
  TypeComponentCtaGroupFields,
  'componentCtaGroup'
>
export type TypeComponentCtaGroupEntry = Entry<
  TypeComponentCtaGroupSkeleton,
  'WITHOUT_UNRESOLVABLE_LINKS',
  'en-US'
>
